function none(){}export default function(selector){return null==selector?none:function(){return this.querySelector(selector)}}